import { render, staticRenderFns } from "./detail-homeWork.vue?vue&type=template&id=144af0b8&scoped=true&"
import script from "./detail-homeWork.vue?vue&type=script&lang=ts&"
export * from "./detail-homeWork.vue?vue&type=script&lang=ts&"
import style0 from "./detail-homeWork.vue?vue&type=style&index=0&id=144af0b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144af0b8",
  null
  
)

export default component.exports